import React from 'react'

const BellOutline = props => (
  <svg width={25} height={25} fill="none" {...props}>
    <path
      fillRule="evenodd"
      d="M21.83 17.25L20 16.03v-4a7.84 7.84 0 00-6.75-8v-1a.75.75 0 00-1.5 0v1a7.84 7.84 0 00-6.75 8v4l-1.83 1.22A1.5 1.5 0 004 20h6.57a2.075 2.075 0 00-.07.5 2 2 0 104 0 2.085 2.085 0 00-.07-.5H21a1.5 1.5 0 00.83-2.75zM13 20.5a.5.5 0 11-1 0 .5.5 0 011 0zm-6.5-3.67L4 18.5h17l-2.5-1.67V12a6.27 6.27 0 00-6-6.5 6.27 6.27 0 00-6 6.5v4.83zm12-12.8a.75.75 0 011-1.06l2 2a.75.75 0 01-1.06 1.06l-1.94-2zm-15 .94a.75.75 0 000 1.06.75.75 0 001 0l2-2a.75.75 0 00-1-1.06l-2 2z"
      fill={props.fill || '#6b8fbc'}
    />
  </svg>
)

export default BellOutline
